(ns common.security.authentication
  (:require [common.localization :as loc]
            [common.features.plan :as plan]))

(def auth-options [:authentication.type/password-only
                   :authentication.type/optional-2FA
                   :authentication.type/mandatory-2FA])

(def options (->> auth-options
                  (map (fn [k]
                         {:value k
                          :label (loc/tr k)}))
                  (into [])))

(defn mfa-on? [tenant]
  (let [feature-on? (plan/available :feature/authentication-2fa tenant)
        {:keys [tenant/authentication-setting]} tenant]
    (and feature-on?
         (some #{authentication-setting} [:authentication.type/optional-2FA :authentication.type/mandatory-2FA]))))

(defn mfa-mandatory? [tenant]
  (let [feature-on? (plan/available :feature/authentication-2fa tenant)
        {:keys [tenant/authentication-setting]} tenant]
    (and feature-on?
         (= authentication-setting :authentication.type/mandatory-2FA))))
